import { ThreadEvents } from "../../../../types"
import If from "../../if"
import Tooltip from "../../tool-tip"

interface Props {
  events: ThreadEvents
}

const EventsTooltip = ({ events }: Props) => {
  let dashClickedCount = 0

  // Loop the events and find if summary sent
  events.forEach(event => {
    const dashClicked = event.type === "dashboard_link_clicked"
    if (dashClicked) {
      dashClickedCount++
    }
    return dashClicked
  })

  const hasImmediateCall = events.some(event => event.type === "immediate_call")
  const hasScheduledCall = events.some(event => event.type === "scheduled_call")

  let countLiItems = 0

  if (dashClickedCount > 0) {
    countLiItems++
  }
  if (hasScheduledCall) {
    countLiItems++
  }
  if (hasImmediateCall) {
    countLiItems++
  }

  return (
    <If
      condition={countLiItems > 0}
      then={
        <Tooltip
          toolTipNode={<span>🔥 {countLiItems}+</span>}
          text={
            <ul className="text-[10px]">
              <If
                condition={dashClickedCount > 0}
                then={
                  <li>
                    <span className="inline-block mr-1 -rotate-90">🧲</span>{" "}
                    Dash link clicked {dashClickedCount}x
                  </li>
                }
              />
              <If
                condition={hasScheduledCall}
                then={
                  <li>
                    <span className="inline-block mr-1">🗓️</span> Scheduled call
                  </li>
                }
              />
              <If
                condition={hasImmediateCall}
                then={
                  <li>
                    <span className="inline-block mr-1">☎</span> Immediate Call
                  </li>
                }
              />
            </ul>
          }
          placement="top"
        />
      }
    />
  )
}

export default EventsTooltip
